import clsx from "clsx";
import { Profile, TenantIdSelectInput } from "components";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTenant } from "store/contextTenant";
import { Tab } from "utils/types";
import "./styles.scss";

export interface HeaderBackofficeProps {
	tabs?: { [name: string]: Tab };
}

export default function HeaderBackoffice(
	props: Readonly<HeaderBackofficeProps>
) {
	const { tabs } = props;
	const navigate = useNavigate();
	const locationPathName = window.location.pathname;
	const [toggleAvatarMenu, setToggleAvatarMenu] = useState<boolean>(false);
	const contextTenant = useTenant();

	function isAbleToRoutes(isNecessaryTenant: boolean) {
		return !isNecessaryTenant || (isNecessaryTenant && contextTenant.tenant);
	}

	const CheckPathTenant = useMemo(() => {
		if (locationPathName.startsWith("/backoffice/tenants")) {
			return true;
		}
		return false;
	}, [locationPathName]);

	const handleToggleAvatarMenu = () => {
		if (!toggleAvatarMenu) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}
		setToggleAvatarMenu(!toggleAvatarMenu);
	};

	return (
		<header className="header-backoffice">
			<div className="title-selector-wrapper">
				<button
					className="font-body-semibold-large"
					onClick={() => navigate("/backoffice")}
				>
					Admin CCR
				</button>
				{!CheckPathTenant && <TenantIdSelectInput />}
			</div>
			<nav className="tab-wrapper">
				{tabs &&
					Object.entries(tabs).map(
						([tabKey, tabValue]) =>
							isAbleToRoutes(tabValue.isNecessaryTenant) && (
								<ul key={`tab-${tabKey}`}>
									<li
										key={`tab-${tabKey}`}
										role="presentation"
										onClick={() => navigate(tabValue.baseUrl)}
										className={clsx({
											"active-header-tab": locationPathName.startsWith(
												tabValue.baseUrl
											)
										})}
									>
										<span className="font-body-regular-small">
											{tabValue.title}
										</span>
									</li>
								</ul>
							)
					)}
			</nav>
			<div className="profile-wrapper">
				<div className="divider" />
				<Profile onClose={handleToggleAvatarMenu} />
			</div>
		</header>
	);
}
